module.exports = __webpack_public_path__ + "static/media/ship-small@2x.0f481170.png";